import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useQueryProperties from '@hooks/useQueryProperties'
import {
  PointGoogle,
  Property,
  RealEstateData,
  RealEstateDataPageComponentData,
  StatePropertiesSlice,
} from 'types'
import { getOperationView } from '@helpers/helper.filters'
import {
  changeSelectedAction,
  changeViewId,
  reduxUpdateOrderBy,
  updateCoordinatesAction,
  updateFocusProperty,
  updateOffsetAction,
  updatePolygonAction,
} from '@slices/propertiesSlice'
import {
  addMarker,
  changeFormat,
  checkMarker,
  handlerClick,
  reCalculateCoordinateMarkers,
  scrollOnGrid,
  smoothZoomIn,
  smoothZoomOut,
} from '@helpers/helper.map'
import mapStyles from './mapStyles.json'
import { getPrices, searchUnitiesInResults } from '@helpers/helper.properties'
import Grid_Properties_1 from '@components/gridProperties/1'
import { APIProvider, Map, useMap } from '@vis.gl/react-google-maps'
import Markers from './Markers'
import {} from '@vis.gl/react-google-maps'
import Paginate from '@components/paginate/1'
import Loader from '../LoaderMap'
import HeaderResults from '@components/headerProperties/1'
import {
  MapContainer,
  TileLayer,
  Marker as MarkerLeaflet,
  Popup,
  ZoomControl,
  useMap as useMapLeaflet,
  FeatureGroup,
  Marker,
} from 'react-leaflet'

import { EditControl } from 'react-leaflet-draw'
import 'leaflet-draw/dist/leaflet.draw.css'
import L, { Control } from 'leaflet'
import useSupercluster from 'use-supercluster'
import { getPriceForMarker } from '@helpers/helper.rendering'

import { Modal as ModalBootstrap } from 'bootstrap'

const icons: any = {}

const fetchIcon = (count: number, size: number) => {
  if (!icons[count]) {
    icons[count] = L.divIcon({
      html: `<div class="cluster-marker" style="width: ${size}px; height: ${size}px;">
        ${count}
      </div>`,
    })
  }
  return icons[count]
}

const Results_Properties_1 = (props: RealEstateDataPageComponentData) => {
  const { global_data, includeTag } = props
  const GOOGLE_KEY = global_data.pageConfig.keys.map
  const propCard = global_data?.content?.cardsProperties?.type_id || '1'
  const devCard = global_data?.content?.cardsDevelopments?.type_id || '1'

  const [sidebar] = useState(true)

  const [heightView, setHeightView] = useState('0px')

  const [maxPropertiesLoaded, setMaxPropertiesLoaded] = useState(1000)
  const [points, setPoints] = useState<PointGoogle[]>([])

  const [isLoadingMap, setIsLoadingMap] = useState(true)

  // const [mapLeaflet, setMapLeaflet] = useState<any>([])

  const [center, setCenter] = useState({ lat: -34.5275818, lng: -58.5052437 })
  const [zoom, setZoom] = useState(11)
  const {
    filters,
    offset,
    orders,
    coordinates,
    polygonCoordinates,
    selected,
    viewId, // map,
  }: StatePropertiesSlice = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )

  const API_KEY = global_data.pageConfig.keys.tokko
  const {
    properties,
    isLoading: isLoadingProperties,
    isFetching: isFetchingProperties,
  } = useQueryProperties({
    filters,
    coordinates,
    polygonCoordinates,
    orders,
    offset,
    tokkoKey: API_KEY,
    custom_tags: includeTag ? includeTag.map((tag) => Number(tag)) : [],
  })

  const isSSR = typeof window === 'undefined'

  const Card = require(`@components/cardsProperties/${propCard}`)?.default
  // const DevCard = require(`@components/cardsDevelopments/${devCard}`)?.default

  const dispatch = useDispatch()

  useEffect(() => {
    scrollTo({ top: 0, behavior: 'smooth' })
  }, [properties])

  useEffect(() => {
    var screenWidth = screen.width
    if (screenWidth < 992) {
      dispatch(changeViewId(2))
    }
  }, [])

  const order_properties_mediacore = (properties: Property[]) => {
    let properties_order = properties?.map((prop) => prop)
    if (API_KEY) {
      return properties_order
    }
    switch (orders?.order_by) {
      case 'id': {
        let response = properties_order?.sort((a, b) => a.id - b.id)
        if (orders.order === 'desc') {
          response?.reverse()
        }
        return response
      }
      case 'price': {
        let response = properties_order?.sort(
          (a: Property, b: Property) =>
            a.operations.find(
              (op) =>
                op.operation_type?.toLowerCase() ===
                filters.operation?.toLowerCase().replace('temporario', 'alquiler temporario'),
            )?.prices.price -
            b.operations.find(
              (op) =>
                op.operation_type?.toLowerCase() ===
                filters.operation?.toLowerCase().replace('temporario', 'alquiler temporario'),
            )?.prices.price,
        )
        if (orders.order === 'desc') {
          response?.reverse()
        }
        return response
      }
      case 'total_surface': {
        let response = properties_order.map((prop) => ({
          ...prop,
          surface_to_filter:
            prop.type.name === 'Campo' || prop.type.name === 'Terreno'
              ? prop.surface
              : prop.total_surface,
        }))
        response = response.sort((a: any, b: any) => a.surface_to_filter - b.surface_to_filter)
        if (orders.order === 'desc') {
          response?.reverse()
        }
        return response
      }
      default:
        return properties
    }
  }

  function onLoadFunction() {}

  const textUpper = (text: string) => text?.replace(text[0], text[0]?.toUpperCase())

  const selectorOrder = useRef<any>()

  function traductorSelect() {
    switch (selectorOrder.current?.value) {
      case '0':
        dispatch(reduxUpdateOrderBy({ order: 'desc', order_by: 'price' }))
        break
      case '1':
        dispatch(reduxUpdateOrderBy({ order: 'asc', order_by: 'price' }))
        break
      case '2':
        dispatch(reduxUpdateOrderBy({ order: 'desc', order_by: 'id' }))
        break
      case '3':
        dispatch(reduxUpdateOrderBy({ order: 'asc', order_by: 'id' }))
        break
      case '4':
        dispatch(reduxUpdateOrderBy({ order: 'desc', order_by: 'total_surface' }))
        break
      case '5':
        dispatch(reduxUpdateOrderBy({ order: 'asc', order_by: 'total_surface' }))
        break
    }
  }

  const getLimit = (properties: Property[]) => {
    const response = []
    if (!properties) {
      return []
    }
    if (properties?.length > maxPropertiesLoaded) {
      for (let i = 0; i < properties.length; i++) {
        if (i < maxPropertiesLoaded) {
          response.push(properties[i])
        }
      }
      return order_properties_mediacore(response)
    }
    return order_properties_mediacore(properties)
    // return properties.filter(prop => prop?.development?.display_on_web !== true)
  }

  useEffect(() => {
    var headerHeight = document?.getElementById('header')?.offsetHeight!
    var filterBarHeight = document?.getElementById('handle-filter-bar')?.offsetHeight!
    var totalHeight = headerHeight + filterBarHeight + 'px'
    setHeightView(totalHeight)
  }, [properties])

  // Leaflet functions

  const { focusPropertyId }: StatePropertiesSlice = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )

  const [mapLeaflet, setMapLeaflet] = useState<any>([])
  const [boundsLeaflet, setBoundsLeaflet] = useState<any[]>([])
  const [backup, setBackup] = useState<any>([])

  const CustomMarker = ({ position, cluster }: any) => {
    if (!cluster.property) {
      return <></>
    } // Caso de cluster
    const { property } = cluster
    const isDevelopment = property.development !== null
    let customMarkerLeaflet
    if (property.development !== null) {
      if (property.development.display_on_web === false) {
        return <></>
      }
      customMarkerLeaflet = L.divIcon({
        // Caso de que sea un enmprendimiento
        className:
          'crime-marker ' +
          (cluster.properties.propId === selected && ' selected-marker ') +
          (cluster.property.development.display_on_web && ' is_development ') +
          (checkMarker(
            cluster.property.development?.id?.length > 1
              ? cluster.property.development?.id
              : cluster.properties.propId,
          )
            ? ' active '
            : ''),
        html:
          '<div class="custom-marker center"><i class="icon-marker-emprendimiento"></i><h5>' +
          searchUnitiesInResults(properties, cluster.property.development?.id)?.length +
          '</h5><div class="delete-selected"></div></div>',
        iconSize: [45, 55],
      })
    } else {
      customMarkerLeaflet = L.divIcon({
        // Caso de que sea una propiedad
        className:
          'crime-marker ' +
          (cluster.properties.isCenterPoint ? ' center-marker ' : '') +
          (filters.operation.includes('venta') ? ' venta-marker ' : ' alquiler-marker ') +
          (selected?.toString() !== '0' &&
          cluster?.properties?.propId.toString() !== selected?.toString()
            ? ' opacity-marker '
            : '') +
          (cluster.properties.propId === selected && ' selected-marker ') +
          (checkMarker(
            cluster.property.development?.id?.length > 1
              ? cluster.property.development?.id
              : cluster.properties.propId,
          )
            ? ' active '
            : ''),
        html:
          '<div class="custom-marker center"><i class="icon-marker"></i><h5>' +
          getPriceForMarker(getPrices(cluster.property, filters.operation)) +
          '</h5><div class="delete-selected"></div></div>',
        iconSize: [45, 55],
      })
    }

    const handleMarkerClick = () => {
      dispatch(changeSelectedAction(cluster.properties.propId))
      addMarker(cluster.properties.propId)
      scrollOnGrid(cluster.properties.propId)
      if (isDevelopment || viewId === 1) {
        // toggleModal(true)
        const element = document.getElementById('exampleModal') as HTMLElement
        const myModal = new ModalBootstrap(element)
        myModal?.show()
      }
    }

    const handleMarkerMouseOver = () => {}

    const handleMarkerMouseOut = () => {}

    return (
      <MarkerLeaflet
        eventHandlers={{
          click: (e) => handleMarkerClick(),
          mouseover: (e) => handleMarkerMouseOver(),
          mouseout: (e) => handleMarkerMouseOut(),
        }}
        icon={customMarkerLeaflet}
        position={position}
      ></MarkerLeaflet>
    )
  }

  const RenderMarkersLeaflet = () => {
    // const markerCoords = []; // arreglo para guardar coordenadas de marcadores
    const maxZoom = 18
    const [bounds, setBounds] = useState<any>(null)
    const [zoom, setZoom] = useState(15)
    const map = useMapLeaflet()
    const [pointsLeaflet, setPointsLeaflet] = useState([])

    const centerDynamic = (new_points: any = []) => {
      if (polygonCoordinates.length === 0 && coordinates.length === 0) {
        const markerCoords: any = [] // arreglo para guardar coordenadas de marcadores
        for (const iterator of new_points) {
          markerCoords.push([iterator.geometry.coordinates[1], iterator.geometry.coordinates[0]]) // agregar coordenadas al arreglo
        }
        if (markerCoords.length) {
          // ajustar vista del mapa para incluir todos los marcadores
          map.fitBounds(markerCoords)
          if (map.getZoom() > 16) {
            map.setView(map.getCenter(), 15)
          }
        }
      }
    }

    useEffect(() => {
      let new_points: any = []
      reCalculateCoordinateMarkers(properties?.objects || properties).map((property) => {
        property.development ? (
          <>
            {new_points.find(
              (element: { property: { development: { id: any } } }) =>
                element.property.development?.id === property.development?.id &&
                property.development?.display_on_web,
            )
              ? null
              : new_points.push({
                  type: 'Feature',
                  property: property,
                  properties: {
                    cluster: false,
                    propId: property.id,
                    address: property.address,
                  },
                  geometry: {
                    type: 'Point',
                    coordinates: [
                      parseFloat(changeFormat(property?.geo_long)!),
                      parseFloat(changeFormat(property.geo_lat)!),
                    ],
                  },
                })}
          </>
        ) : false ? null : (
          new_points.push({
            type: 'Feature',
            property: property,
            properties: {
              cluster: false,
              propId: property.id,
              address: property.address,
            },
            geometry: {
              type: 'Point',
              coordinates: [
                // parseFloat(changeFormat((zoom > 17 && property.geo_long_changed ? property.geo_long_changed : property.geo_long))),
                // parseFloat(changeFormat((zoom > 17 && property.geo_long_changed ? property.geo_lat_changed : property.geo_lat))),
                parseFloat(changeFormat(property.geo_long)!),
                parseFloat(changeFormat(property.geo_lat)!),
              ],
            },
          }) +
          (property.offsetChanged &&
          zoom > 17 &&
          new_points.find(
            (element: { geometry: { coordinates: any[] } }) =>
              element.geometry.coordinates[0] === property.geo_long_changed &&
              element.geometry.coordinates[1] === property.geo_lat_changed,
          )
            ? new_points.push({
                type: 'Feature',
                property: property,
                properties: {
                  cluster: false,
                  propId: property.id + Math.random,
                  address: property.address,
                  isCenterPoint: true,
                },
                geometry: {
                  type: 'Point',
                  coordinates: [
                    parseFloat(changeFormat(property.geo_long)!),
                    parseFloat(changeFormat(property.geo_lat)!),
                  ],
                },
              })
            : null)
        )
      })

      if (
        boundsLeaflet.length === 0 &&
        coordinates.length === 0 &&
        polygonCoordinates.length === 0
      ) {
        if (
          properties?.objects?.length! > 0 &&
          (backup?.objects?.length === 0 || backup?.objects?.length === undefined)
        ) {
          //Primera carga
          centerDynamic(new_points)
        } else if (properties?.objects?.length! > 0 && backup?.objects?.length > 0) {
          if (properties?.objects[0].id !== backup?.objects[0].id) {
            //Cuando pagino o filtro, que las propiedades son diferentes a las que estaban antes
            centerDynamic(new_points)
          }
        }
      }

      setPointsLeaflet(new_points)
      setBackup(properties)
    }, [properties, zoom, selected])

    useEffect(() => {
      // if(isFirstRender){
      //   if(map !== []){
      //     if(map.getZoom() > 16){
      //       console.log(map.getZoom())
      //       map.setView(map.getCenter(),15)
      //     }
      //   }
      // }
    }, [zoom])

    useEffect(() => {
      map.invalidateSize()
      if (polygonCoordinates.length === 0) {
        map.eachLayer(function (layer) {
          if (layer instanceof L.Path || layer instanceof L.Marker) {
            map.removeLayer(layer)
          }
        })
      }
    }, [viewId])

    useEffect(() => {
      // if(coordinates.length === 0){
      //   if(boundsLeaflet.length !== 0){
      //     setBoundsLeaflet([])
      //   }
      // }
    }, [coordinates])

    // get map bounds
    function updateMap() {
      const b = map?.getBounds()
      setBounds([
        b.getSouthWest().lng,
        b.getSouthWest().lat,
        b.getNorthEast().lng,
        b.getNorthEast().lat,
      ])
      setZoom(map.getZoom())
    }

    const onMove = useCallback(() => {
      updateMap()
    }, [map])

    useEffect(() => {
      updateMap()
      setMapLeaflet(map)
      setIsLoadingMap(false)
      //@ts-ignore
      L.Control.DeleteButtonControl = L.Control.extend({
        onAdd: function (map: any) {
          // Verificar si el control ya existe
          var existingControl = document.querySelector('.leaflet-bar.delete-control')
          this.removePreviousButton()
          // if (existingControl) {
          //   return existingControl;
          // }

          var controlDiv = L.DomUtil.create('div', 'leaflet-bar delete-control')
          controlDiv.innerHTML =
            '<button class="delete-button-leaflet"' +
            (polygonCoordinates.length === 0 && coordinates.length === 0 ? 'disabled' : '') +
            '> <i class="icon-trash"></i></button>'

          // Agregar evento click al botón para eliminar las capas de formas
          var deleteButton = controlDiv.querySelector('.delete-button-leaflet')
          deleteButton?.addEventListener('click', function () {
            dispatch(updatePolygonAction([]))
            dispatch(updateCoordinatesAction([]))
            setBoundsLeaflet([])
            map.eachLayer(function (layer: any) {
              if (layer instanceof L.Path) {
                map.removeLayer(layer)
              }
            })
          })
          return controlDiv
        },

        onRemove: function () {
          // No es necesario hacer nada aquí
        },

        removePreviousButton: function () {
          var previousButton = document.querySelector('.leaflet-bar.delete-control')
          if (previousButton) {
            previousButton.remove()
          }
        },
      })
      //@ts-ignore
      L.control.deleteButtonControl = function (opts) {
        //@ts-ignore
        return new L.Control.DeleteButtonControl(opts)
      }
      L.control
        //@ts-ignore
        .deleteButtonControl({
          position: 'topright',
        })
        .addTo(map)
      //@ts-ignore
      L.drawLocal = {
        draw: {
          toolbar: {
            // #TODO: this should be reorganized where actions are nested in actions
            // ex: actions.undo  or actions.cancel
            actions: {
              title: 'Cancelar',
              text: 'Cancelar',
            },
            finish: {
              title: 'Finalizar',
              text: 'Finalizar',
            },
            undo: {
              title: 'Deshacer último punto',
              text: 'Deshacer último punto',
            },
            buttons: {
              polyline: 'Polyline',
              polygon: 'Poligono',
              rectangle: '- your text-',
              circle: '- your text-',
              marker: '- your text-',
              circlemarker: '- your text-',
            },
          },
          handlers: {
            circle: {
              tooltip: {
                start: '- your text-',
              },
              radius: '- your text-',
            },
            circlemarker: {
              tooltip: {
                start: '- your text-.',
              },
            },
            marker: {
              tooltip: {
                start: '- your text-.',
              },
            },
            polygon: {
              tooltip: {
                start: 'Has clic para comenzar a trazar el área',
                cont: 'Has otro clic para seguir trazando el área',
                end: 'Has otro clic para seguir trazando el área',
              },
            },
            polyline: {
              error: '<strong>Error:</strong> shape edges cannot cross!',
              tooltip: {
                start: 'Click to start drawing line.',
                cont: 'Click to continue drawing line.',
                end: 'Click last point to finish line.',
              },
            },
            rectangle: {
              tooltip: {
                start: '- your text-.',
              },
            },
            simpleshape: {
              tooltip: {
                end: 'Release mouse to finish drawing.',
              },
            },
          },
        },
        edit: {
          toolbar: {
            actions: {
              save: {
                title: 'Save changes',
                text: 'Save',
              },
              cancel: {
                title: 'Cancel editing, discards all changes',
                text: 'Cancel',
              },
              clearAll: {
                title: 'Clear all layers',
                text: 'Clear All',
              },
            },
            buttons: {
              edit: 'Edit layers',
              editDisabled: 'No layers to edit',
              remove: 'Delete layers',
              removeDisabled: 'No layers to delete',
            },
          },
          handlers: {
            edit: {
              tooltip: {
                text: 'Drag handles or markers to edit features.',
                subtext: 'Click cancel to undo changes.',
              },
            },
            remove: {
              tooltip: {
                text: 'Click on a feature to remove.',
              },
            },
          },
        },
      }
    }, [map, polygonCoordinates])

    useEffect(() => {
      map.on('move', onMove)
      return () => {
        map.off('move', onMove)
      }
    }, [map, onMove])

    useEffect(() => {
      let new_points: any = []
      reCalculateCoordinateMarkers(properties?.objects || properties).map((property) => {
        property.development ? (
          <>
            {new_points.find(
              (element: { property: { development: { id: any } } }) =>
                element.property.development?.id === property.development?.id &&
                property.development?.display_on_web,
            )
              ? null
              : new_points.push({
                  type: 'Feature',
                  property: property,
                  properties: {
                    cluster: false,
                    propId: property.id,
                    address: property.address,
                  },
                  geometry: {
                    type: 'Point',
                    coordinates: [
                      parseFloat(
                        changeFormat(
                          property.geo_long_changed ? property.geo_long_changed : property.geo_long,
                        )!,
                      ),
                      parseFloat(
                        changeFormat(
                          property.geo_lat_changed ? property.geo_lat_changed : property.geo_lat,
                        )!,
                      ),
                    ],
                  },
                })}
          </>
        ) : false ? null : (
          new_points.push({
            type: 'Feature',
            property: property,
            properties: {
              cluster: false,
              propId: property.id,
              address: property.address,
            },
            geometry: {
              type: 'Point',
              coordinates: [
                parseFloat(
                  changeFormat(
                    zoom > 27 && property.geo_long_changed
                      ? property.geo_long_changed
                      : property.geo_long,
                  )!,
                ),
                parseFloat(
                  changeFormat(
                    zoom > 27 && property.geo_long_changed
                      ? property.geo_lat_changed
                      : property.geo_lat,
                  )!,
                ),
              ],
            },
          }) +
          (property.offsetChanged &&
          zoom > 27 &&
          new_points.find(
            (element: { geometry: { coordinates: any[] } }) =>
              element.geometry.coordinates[0] === property.geo_long_changed &&
              element.geometry.coordinates[1] === property.geo_lat_changed,
          )
            ? new_points.push({
                type: 'Feature',
                property: property,
                properties: {
                  cluster: false,
                  propId: property.id + Math.random,
                  address: property.address,
                  isCenterPoint: true,
                },
                geometry: {
                  type: 'Point',
                  coordinates: [
                    parseFloat(changeFormat(property.geo_long)!),
                    parseFloat(changeFormat(property.geo_lat)!),
                  ],
                },
              })
            : null)
        )
      })

      if (selected === 0) {
        // // // // // centerDynamic(new_points)
      }
    }, [selected])

    useEffect(() => {
      if (focusPropertyId) {
        const prop = properties?.objects.find((prop) => prop.id === focusPropertyId)!
        map?.setZoom(18)
        map?.panTo({ lat: parseFloat(prop.geo_lat), lng: parseFloat(prop.geo_long) })
      } else {
        if (map.getZoom() == 18) {
          map?.setZoom(16)
        }
      }
    }, [focusPropertyId])

    const { clusters: leafletClusters, supercluster: leafletSuperCluster } = useSupercluster({
      points: pointsLeaflet,
      //@ts-ignore
      bounds,
      zoom,
      options: { radius: 100, maxZoom: 17 },
    })

    const getExpansionZoom = (cluster: { id: any; geometry: { coordinates: [any, any] } }) => {
      const currentZoom = map.getZoom()
      const clusterExpansionZoom = leafletSuperCluster.getClusterExpansionZoom(cluster.id)
      let zoom_custom = currentZoom
      const [longitude, latitude] = cluster.geometry.coordinates
      for (let index = 0; index < clusterExpansionZoom - currentZoom; index++) {
        zoom_custom += 1
        map.setView([latitude, longitude], zoom_custom, {
          duration: 0.7, // Duración de la animación en segundos
          easeLinearity: 0, // Controla la suavidad de la animación (valor entre 0 y 1)
        })
      }
      return Math.min(clusterExpansionZoom, currentZoom + 1)
    }

    return leafletClusters.map(
      (cluster: {
        geometry: { coordinates: [any, any] }
        properties: { propId?: any; cluster?: any; point_count?: any; isCenterPoint?: any }
        id: any
      }) => {
        const [longitude, latitude] = cluster.geometry.coordinates
        const {
          cluster: isCluster,
          point_count: pointCount,
          isCenterPoint: centerPoint,
        } = cluster.properties
        if (isCluster) {
          return (
            <MarkerLeaflet
              key={`cluster-${cluster.id}`}
              position={[latitude, longitude]}
              icon={fetchIcon(pointCount, 10 + (pointCount / pointsLeaflet.length) * 40)}
              eventHandlers={{
                click: () => {
                  // getExpansionZoom(cluster)
                  const expansionZoom = Math.min(
                    leafletSuperCluster?.getClusterExpansionZoom(cluster.id),
                    maxZoom,
                  )
                  if (expansionZoom > 17) {
                    map.flyTo([latitude, longitude], expansionZoom, {
                      duration: 0.5, // Duración de la animación en segundos
                      easeLinearity: 0, // Controla la suavidad de la animación (valor entre 0 y 1)
                    })
                  } else {
                    map.setView([latitude, longitude], expansionZoom, {
                      animate: true,
                    })
                  }
                  // map.panTo({ lat: latitude, lng: longitude });
                },
              }}
            />
          )
        }
        return (
          <CustomMarker
            cluster={cluster}
            key={`crime-${cluster.properties.propId}`}
            position={[latitude, longitude]}
          ></CustomMarker>
        )
      },
    )
  }

  const handleShapeDelete = () => {
    dispatch(updatePolygonAction([]))
  }

  const handleShapeCreated = (e: { layer: { _latlngs: { lat: any; lng: any }[][] } }) => {
    let polygon: { lat: string; lng: string }[] = []
    //Obtengo las coordenadas del polygon
    e.layer._latlngs[0].map((point: { lat: any; lng: any }, index: any) =>
      polygon.push({ lat: point.lat, lng: point.lng }),
    )
    dispatch(updatePolygonAction(polygon))
  }

  const handleShapeEdited = (event: { layers: any }) => {
    const editedLayers = event.layers
    let polygon: { lat: string; lng: string }[] = []
    editedLayers.eachLayer((layer: { getLatLngs: () => any }) => {
      const coordinates = layer.getLatLngs() // Obtén las coordenadas actualizadas
      //Obtengo las coordenadas del polygon
      coordinates.map((point: any) =>
        point.map((coord: { lat: any; lng: any }) => {
          polygon.push({ lat: coord.lat, lng: coord.lng })
        }),
      )
    })

    dispatch(updatePolygonAction(polygon))
    // setShape(polygon)
    // dispatch(REDUX_UPDATE_DRAWN_POLYGON(poly))
  }

  const updateBoundsLeaflet = () => {
    if (coordinates.length > 0) {
      return setBoundsLeaflet([])
    }
    const bounds = mapLeaflet.getBounds()
    setBoundsLeaflet([
      bounds.getNorthWest().lng,
      bounds.getSouthEast().lng,
      bounds.getSouthEast().lat,
      bounds.getNorthWest().lat,
    ])
  }

  useEffect(() => {
    if (boundsLeaflet.length !== 0) {
      dispatch(updateOffsetAction(0))
      dispatch(updateCoordinatesAction(boundsLeaflet))
    }
  }, [boundsLeaflet])

  return (
    <>
      <div
        className={'results-map a ' + (viewId == 2 ? 'go-down-index' : '')}
        style={{ height: `calc(100vh - ${heightView}` }}
      >
        <div
          className={
            'd-flex wraper-map-view ' +
            (properties?.meta?.total_count < 50 || polygonCoordinates.length > 0
              ? 'full-height'
              : '')
          }
        >
          <div
            id="grid-map"
            className={'position-relative ' + (viewId !== 0 ? 'not-visible' : '')}
          >
            <div
              // onScroll={() =>
              //   selected !== 0 && !scrolling && resetSelectedAndCenterMap()
              // }

              style={{ height: `calc(100vh - ${heightView}` }}
              id="sidebarElement"
              className={'sidebar-properties pb-0 ' + (sidebar ? '' : 'close-sidebar')}
            >
              <div className="sidebar-properties-header pt-2 d-flex">
                <div className="section-title">
                  {(isLoadingProperties || isFetchingProperties) && <h4>Cargando propiedades..</h4>}
                  {!isLoadingProperties && !isFetchingProperties && (
                    <h4 className="mb-0">
                      {isLoadingProperties || isFetchingProperties
                        ? 'Cargando'
                        : properties?.meta?.total_count}{' '}
                      {'Propiedades en'}{' '}
                      <div className="">{' ' + textUpper(getOperationView(filters))}</div>
                    </h4>
                  )}
                  {/* <h5>{loading ? 'Cargando' : totalCount} resultados totales de búsqueda. </h5> */}
                </div>
                <div
                  className={
                    'justify-content-end d-flex align-items-center mb-4 mb-lg-0 me-3 ' +
                    (properties?.objects?.length === 0 &&
                      !isLoadingProperties &&
                      !isFetchingProperties &&
                      ' d-none')
                  }
                  id="orderBy"
                >
                  Ordenar por:
                  <div className="content-select">
                    <select
                      ref={selectorOrder}
                      onChange={() => traductorSelect()}
                      className="text-end"
                      name="orderby"
                      id="sort"
                    >
                      <option value="2">Publicaciones más recientes</option>
                      <option value="3">Publicaciones más antiguas</option>
                      <option value="0">Mayor precio</option>
                      <option value="1">Menor precio</option>
                      <option value="4">Mayor superficie</option>
                      <option value="5">Menor superficie</option>
                    </select>
                    <i />
                  </div>
                </div>
              </div>
              {isLoadingProperties || isFetchingProperties ? (
                [1, 2, 3, 4].map((index) => (
                  <Card
                    key={index}
                    global_data={global_data}
                    grid_map={true}
                    skeleton={true}
                  />
                ))
              ) : (
                <div className="sidebar-properties-body">
                  {getLimit(properties?.objects!)?.length === 0 &&
                    !isLoadingProperties &&
                    !isFetchingProperties && (
                      <h5 className="text-center mt-lg-5 mt-3">
                        No hay resultados para esta búsqueda.
                      </h5>
                    )}
                  {getLimit(properties?.objects!).map((property, index) =>
                    // (properties?.objects?.find(element => element.id === selected)?.development?.id > 0 &&
                    // (properties?.objects?.find(element => element.id === selected)?.development?.display_on_web) ||
                    property.id === selected || selected === 0 || selected === 0 || !selected ? (
                      <div
                        key={index}
                        className={index !== 0 ? 'mt-3' : ''}
                      >
                        <Card
                          global_data={global_data}
                          key={index}
                          // map={API_KEY === '' ? mapLeaflet : map}
                          setZoom={setZoom}
                          handlerClick={handlerClick}
                          isLeaflet={API_KEY === ''}
                          grid_map={true}
                          property={property}
                        />
                        {/* <hr /> */}
                      </div>
                    ) : (
                      <div
                        key={index}
                        className="mt-3"
                      >
                        <Card
                          global_data={global_data}
                          // map={GOOGLE_KEY === '' ? mapLeaflet : map}
                          setZoom={setZoom}
                          handlerClick={handlerClick}
                          isLeaflet={GOOGLE_KEY === ''}
                          opacity={true}
                          grid_map={true}
                          property={property}
                          key={index}
                        />
                        {/* <hr /> */}
                      </div>
                    ),
                  )}
                  {getLimit(properties?.objects!).filter((element) => element.id === selected)
                    .length === 0 &&
                    selected !== 0 && (
                      <div className={'mt-3'}>
                        <Card
                          global_data={global_data}
                          // map={GOOGLE_KEY === '' ? mapLeaflet : map}
                          setZoom={setZoom}
                          handlerClick={handlerClick}
                          isLeaflet={GOOGLE_KEY === ''}
                          grid_map={true}
                          property={properties?.objects?.find(
                            (element: Property) => element.id === selected,
                          )}
                        />
                        <hr />
                      </div>
                    )}
                  {API_KEY && maxPropertiesLoaded < properties?.objects?.length! && (
                    <div className="w-100 d-flex justify-content-center">
                      <div
                        onClick={() => setMaxPropertiesLoaded(maxPropertiesLoaded + 50)}
                        className="btn d-inline-block btn-red mx-auto"
                      >
                        Cargar más propiedades
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div
            className={'map-google ' + (viewId === 1 && 'full-map')}
            style={{ position: 'relative', overflow: 'hidden' }}
          >
            <div className="wrapper-map position-relative">
              <>
                {GOOGLE_KEY !== '' ? (
                  <APIProvider
                    apiKey={GOOGLE_KEY}
                    libraries={['drawing']}
                    onLoad={() => {
                      onLoadFunction()
                    }}
                  >
                    <MapController
                      properties={properties!}
                      points={points}
                      setPoints={setPoints}
                      setIsLoadingMap={setIsLoadingMap}
                    />

                    <div
                      style={{
                        width: '100%',
                        height: `calc(100vh - ${heightView}`,
                      }}
                    >
                      <Map
                        mapId="map"
                        defaultCenter={center}
                        defaultZoom={zoom}
                        styles={mapStyles}
                      >
                        <Markers
                          global_data={global_data}
                          points={points}
                        />
                      </Map>
                    </div>
                  </APIProvider>
                ) : (
                  <div
                    style={{
                      width: '100%',
                      height: `calc(100vh - ${heightView}`,
                    }}
                  >
                    <MapContainer // Leaflet Map
                      className="markercluster-map"
                      center={[0, 0]}
                      zoom={10}
                      maxZoom={18}
                      scrollWheelZoom={false}
                      zoomControl={false} // Desactivamos el control de zoom predeterminado
                      // zoomControlPosition="bottomright" // Posicionamos el control de zoom en la esquina inferior derecha
                    >
                      <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" />
                      {/* <TileLayer
                          url="https://api.maptiler.com/maps/dataviz/256/{z}/{x}/{y}.png?key=fzW9HzAb6C93tDpePOno"
                          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        /> */}
                      {/* <Freedraw mode={mode} eventHandlers={handlers} ref={freedrawRef} /> */}
                      <ZoomControl position="bottomright" />{' '}
                      {/* Agregamos nuestro propio control de zoom */}
                      <FeatureGroup>
                        <div className="custom-draw-control">
                          {coordinates.length === 0 && polygonCoordinates.length === 0 && (
                            <EditControl
                              position="topright"
                              draw={{
                                rectangle: false,
                                circle: false,
                                polygon: true,
                                marker: false,
                                circlemarker: false,
                                polyline: false,
                              }}
                              onCreated={handleShapeCreated}
                              onEdited={handleShapeEdited}
                              onDeleted={handleShapeDelete}
                            />
                          )}
                          <button
                            // disabled={boundsLeaflet[0] === currentBoundsLeaflet[0] && boundsLeaflet[1] === currentBoundsLeaflet[1]}
                            disabled={coordinates.length > 0}
                            className={
                              'btn-searcher leaflet-searcher ' +
                              (coordinates.length > 0 ? ' delete ' : '') +
                              (polygonCoordinates.length > 0 && 'd-none')
                            }
                            onClick={() => updateBoundsLeaflet()}
                          >
                            {coordinates.length === 0 ? (
                              'Ver resultados en esta zona'
                            ) : (
                              <>{properties?.meta?.total_count} resultados en esta zona</>
                            )}
                          </button>
                        </div>
                      </FeatureGroup>
                      <RenderMarkersLeaflet />
                    </MapContainer>
                  </div>
                )}
              </>
              {isLoadingProperties || isFetchingProperties || isLoadingMap ? (
                <Loader
                  isLoadingMap={isLoadingMap}
                  width={'full'}
                />
              ) : (
                ''
              )}
              <Modal
                selected={selected}
                properties={properties!}
                cardPropId={propCard}
                cardDevId={devCard}
                global_data={global_data}
              />
            </div>
            <Paginate
              viewId={viewId}
              global_data={global_data}
            />

            {/* <Paginate viewId={viewId} /> */}
          </div>
        </div>
      </div>
      <div className={'container-fluid ' + (viewId == 2 ? '' : 'go-down-index')}>
        <div className="row justify-content-center">
          <HeaderResults
            is_wide={true}
            global_data={global_data}
            includeTag={includeTag}
          />
          <Grid_Properties_1
            global_data={global_data}
            is_wide={true}
            includeTag={includeTag}
          />
          {/* <Paginate
            viewId={viewId}
            global_data={global_data}
          /> */}
        </div>
      </div>
    </>
  )
}

const Modal = ({
  selected,
  properties,
  cardPropId,
  cardDevId,
  global_data,
}: {
  global_data: RealEstateData
  selected: number
  cardPropId: string | number
  cardDevId: string | number
  properties: { objects: Property[] }
}) => {
  const PropCard = require(`@components/cardsProperties/${cardPropId}`)?.default
  const DevCard = require(`@components/cardsDevelopments/${cardDevId}`)?.default

  return (
    <div
      className="modal fade modal-card"
      id={'exampleModal'}
      // tabindex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog d-flex justify-content-center align-items-center modal-dialog modal-dialog-centered">
        <div className="modal-content">
          {selected ? (
            properties?.objects?.find((element) => element.id === selected)?.development?.id! > 0 &&
            properties?.objects?.find((element) => element.id === selected)?.development
              ?.display_on_web ? (
              <DevCard
                inMap={true}
                unities={searchUnitiesInResults(
                  properties,
                  properties?.objects?.find((element) => element.id === selected)?.development?.id,
                )}
                global_data={global_data}
                development={
                  properties?.objects?.find((element) => element.id === selected)?.development
                }
              />
            ) : (
              <PropCard
                inMap={true}
                global_data={global_data}
                property={properties?.objects?.find((element) => element.id === selected)}
                key={selected}
              />
            )
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  )
}

export default Results_Properties_1

const MapController = React.memo(
  ({
    properties,
    points,
    setPoints,
    setIsLoadingMap,
  }: {
    properties: { objects: Property[] }
    points: PointGoogle[]
    setPoints: any
    setIsLoadingMap: any
  }) => {
    const map = useMap()
    const drawingManagerRef = useRef<google.maps.drawing.DrawingManager | null>(null)

    const dispatch = useDispatch()

    const [coordinatesCheck, setCoordinatesCheck] = useState<any>([])
    const [barControllMap, setBarControllMap] = useState<string | null>(null) //null - polygon - pencil

    const [notCenter, setNotCenter] = useState(false)
    const [skipCenter, setSkipCenter] = useState(false)

    const [drawing, setDrawing] = useState(false)

    const [shape, setShape] = useState<any>()

    const { polygonCoordinates, focusPropertyId }: StatePropertiesSlice = useSelector(
      (state: { properties: StatePropertiesSlice }) => state.properties,
    )

    useEffect(() => {
      if (!map) return
      setTimeout(() => {
        const drawingManager = new window.google.maps.drawing.DrawingManager({
          drawingControl: false,
        })
        drawingManagerRef.current = drawingManager
        drawingManager.setMap(map)
        map.setOptions({
          scrollwheel: true,
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: false,
        })
        const styledMap = new google.maps.StyledMapType(mapStyles)
        map.setClickableIcons(false)
        map.mapTypes.set('setMapStyles', styledMap)
        map.setMapTypeId('setMapStyles')
        setIsLoadingMap(false)
      }, 500)
      // do something with the map instance
    }, [map])

    useEffect(() => {
      let new_points: PointGoogle[] = []

      reCalculateCoordinateMarkers(properties?.objects).map((property: Property) => {
        property.development ? (
          <>
            {new_points.find(
              (element: any) =>
                element.property.development?.id === property.development?.id &&
                property.development?.display_on_web,
            )
              ? null
              : new_points.push({
                  type: 'Feature',
                  property: property,
                  properties: {
                    cluster: false,
                    propId: property.id,
                    address: property.address,
                  },
                  geometry: {
                    type: 'Point',
                    coordinates: {
                      lng: parseFloat(
                        changeFormat(
                          property.geo_long_changed ? property.geo_long_changed : property.geo_long,
                        )!,
                      ),
                      lat: parseFloat(
                        changeFormat(
                          property.geo_long_changed ? property.geo_lat_changed : property.geo_lat,
                        )!,
                      ),
                    },
                  },
                })}
          </>
        ) : false ? null : (
          (new_points.push({
            type: 'Feature',
            property: property,
            properties: {
              cluster: false,
              propId: property.id,
              address: property.address,
            },
            geometry: {
              type: 'Point',
              coordinates: {
                lng: parseFloat(
                  changeFormat(
                    property.geo_long_changed ? property.geo_long_changed : property.geo_long,
                  )!,
                ),
                lat: parseFloat(
                  changeFormat(
                    property.geo_long_changed ? property.geo_lat_changed : property.geo_lat,
                  )!,
                ),
              },
            },
          }),
          map &&
          map?.getZoom()! > 16 &&
          property.offsetChanged &&
          new_points?.find(
            (element: any) =>
              element.geometry.coordinates[0] === property.geo_long_changed &&
              element.geometry.coordinates[1] === property.geo_lat_changed,
          )
            ? new_points.push({
                type: 'Feature',
                property: property,
                properties: {
                  cluster: false,
                  propId: property.id + property.id,
                  // propId: property.id + Math.random,
                  address: property.address,
                  isCenterPoint: true,
                },
                geometry: {
                  type: 'Point',
                  coordinates: {
                    lng: parseFloat(changeFormat(property.geo_long)!),
                    lat: parseFloat(changeFormat(property.geo_lat)!),
                  },
                },
              })
            : null)
        )
      })

      if (points !== new_points) {
        setPoints(new_points)
        centerMap(new_points)
      }
      dispatch(changeSelectedAction(0))
    }, [properties, map])

    useEffect(() => {
      if (focusPropertyId) {
        const zoom = map?.getZoom()
        const prop = properties.objects.find((prop) => prop.id === focusPropertyId)!
        //Si está es mayor a 15, hago zoomout
        if (zoom! > 15) {
          smoothZoomOut(map, zoom! - 6, zoom!)
        }
        //Muevo el mapa al seleccionado, si el zoom es mayor a 15, espero el zoom out, y despues lo muevo
        setTimeout(
          () => {
            map?.panTo({ lat: parseFloat(prop.geo_lat), lng: parseFloat(prop.geo_long) })
            setTimeout(() => {
              smoothZoomIn(map, 18, zoom! == 17 ? zoom! - 5 : zoom!)
            }, 400)
          },
          zoom! > 15 ? 1500 : 0,
        )
        dispatch(updateFocusProperty(null))
      }
    }, [focusPropertyId])

    const centerMap = (_points: PointGoogle[]) => {
      if (map) {
        if (polygonCoordinates.length === 0 && _points?.length > 0) {
          if (_points) {
            var boundes = new window.window.google.maps.LatLngBounds()
            for (var i = 0; i < _points.length; i++) {
              var marker = new window.window.google.maps.Marker({
                position: new window.window.google.maps.LatLng(
                  _points[i].geometry.coordinates.lat,
                  _points[i].geometry.coordinates.lng,
                ),
                map: map,
                visible: false,
              })
              boundes.extend(marker.getPosition()!)
            }
            map.fitBounds(boundes)
            if (_points.length == 1) {
              map.setZoom(16)
            }
          }
        }
        // if (polygonCoordinates.length > 0 && points.length > 0) {
        //   setZoom(zoom - 1)
        // }
      }
    }

    const handleSearchProperties = (isRectangle = false) => {
      const mapBorder = map?.getBounds()
      const coordinates = [
        mapBorder?.getSouthWest().lng(),
        mapBorder?.getNorthEast().lng(),
        mapBorder?.getSouthWest().lat(),
        mapBorder?.getNorthEast().lat(),
      ]

      if (coordinates !== coordinatesCheck) {
        setNotCenter(true)
        dispatch(updateOffsetAction(0))
        if (isRectangle) {
          setCoordinatesCheck(coordinates)
          dispatch(updateCoordinatesAction(coordinates))
        }
      }
    }

    // Función de drawing disabled
    function disable() {
      map?.setOptions({
        draggable: false,
        zoomControl: false,
        scrollwheel: false,
        disableDoubleClickZoom: false,
      })
    }

    // Función de drawing enable
    function enable() {
      map?.setOptions({
        draggable: true,
        zoomControl: true,
        scrollwheel: true,
        disableDoubleClickZoom: true,
      })
    }

    const activatePolygonMode = () => {
      if (polygonCoordinates.length === 0) {
        if (window.google && window.google.maps && map) {
          let drawingManager = new window.google.maps.drawing.DrawingManager({
            drawingMode: window.google.maps.drawing.OverlayType.POLYGON,
            drawingControl: false,
          })

          disable()
          drawingManager.setMap(map)
          drawingManagerRef.current = drawingManager
          google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event: any) {
            var element = event.overlay.latLngs.Eg[0].Eg
            var polygon: { lat: string; lng: string }[] = element.map((coordinate: any) => ({
              lat: coordinate.lat(),
              lng: coordinate.lng(),
            }))
            dispatch(updatePolygonAction(polygon))
            enable()
            if (shape !== undefined) {
              shape.setMap(null)
            }
            setShape(event.overlay)
            drawingManager.setMap(null)
            drawingManagerRef.current = drawingManager
          })
        }
      }
    }

    const drawAction = (e: any) => {
      e.preventDefault()
      disable()
      setDrawing(true)
      document.getElementsByTagName('html')[0].classList.add('overflow-hidden')
      if (screen.width < 992) {
        google.maps.event.addDomListener(map!.getDiv(), 'touchstart', function () {
          drawFreeHand()
        })
      } else {
        google.maps.event.addDomListener(map!.getDiv(), 'mousedown', function () {
          drawFreeHand()
        })
      }
    }

    function drawFreeHand() {
      //the polygon
      if (polygonCoordinates.length === 0) {
        let poly = new google.maps.Polyline({
          map: map,
          clickable: false,
        })

        //move-listener
        var move = google.maps.event.addListener(map!, 'mousemove', function (e: any) {
          poly.getPath().push(e.latLng)
        })

        //mouseup-listener
        google.maps.event.addListenerOnce(map!, 'mouseup', function (event: any) {
          google.maps.event.removeListener(move)
          var path = poly.getPath()
          const polydraw = new google.maps.Polygon({
            map: map,
            paths: path,
            clickable: false,
            draggable: false,
          })
          poly.setMap(null)
          setShape(polydraw)
          var element: any = path
          var polygon: { lat: string; lng: string }[] = element.Eg.map((coordinate: any) => ({
            lat: coordinate.lat(),
            lng: coordinate.lng(),
          }))
          dispatch(updatePolygonAction(polygon))
          enable()
          if (shape !== undefined) {
            shape.setMap(null)
          }
          // google.maps.event.clearListeners(map!, 'mousedown')
          google.maps.event.clearListeners(map!.getDiv(), 'touchstart')
          google.maps.event.clearListeners(map!.getDiv(), 'mousedown')
          enable()
          setDrawing(false)
          document.getElementsByTagName('html')[0].classList.remove('overflow-hidden')
          //   setDrawing(false)
          // if (path.length > 0) {
          //   poly.setMap(null)
          //   poly = new google.maps.Polygon({ map: map, path: path })
          //   setShape(poly)
          //   dispatch(REDUX_UPDATE_DRAWN_POLYGON(poly))
          //   let polygon = []
          //   Object.values(poly.latLngs.getArray()[0])[0].map((point, index) =>
          //     polygon.push({ lat: point.toJSON().lat, lng: point.toJSON().lng }),
          //   )
          //   google.maps.event.clearListeners(map!.getDiv(), 'mousedown')
          //   dispatch(REDUX_UPDATE_POLYGON_COORDINATES(polygon))
          //   handleSearchProperties()
          //   enable()
          //   setDrawing(false)
          // }
        })
      }
    }

    function cleanerPolygon() {
      shape?.setMap(null)
      const drawingManager = new window.google.maps.drawing.DrawingManager({
        drawingControl: false,
      })
      drawingManager.setMap(map)
      map?.setOptions({
        draggable: true,
        zoomControl: true,
        scrollwheel: true,
        disableDoubleClickZoom: true,
      })
      setShape(undefined)
      setNotCenter(false)
      setCoordinatesCheck([])
      dispatch(updatePolygonAction([]))
      dispatch(updateCoordinatesAction([]))
    }

    // Do something with the Google Maps map instance
    return (
      <div>
        <div className="control-side">
          <div className="content-button position-relative">
            <button
              disabled={
                // (polygonCoordinates.length > 0 || barControllMap !== null) ||
                // (coordinatesCheck?.length > 0 || coordinatesCheck !== undefined)
                polygonCoordinates.length > 0 ||
                barControllMap !== null ||
                coordinatesCheck?.length > 0
              }
              id={'button-polygon'}
              className={
                'btn-action map-polygon-icon ' + (barControllMap === 'polygon' && 'active')
              }
              onClick={(e) => {
                activatePolygonMode()
                setBarControllMap('polygon')
              }}
            ></button>
            <button
              id="back-hand"
              onClick={(e) => setBarControllMap(null)}
              className={
                'back-to-hand ' +
                (polygonCoordinates.length === 0 && barControllMap === 'polygon' ? '' : 'd-none')
              }
            >
              <div></div>
              <div></div>
            </button>
          </div>
          <div className="content-button position-relative">
            <button
              disabled={
                // (polygonCoordinates.length !== 0 && barControllMap !== null) ||
                // (coordinatesCheck?.length !== 0 || coordinatesCheck !== undefined)
                polygonCoordinates.length > 0 ||
                barControllMap !== null ||
                coordinatesCheck?.length > 0
              }
              id="button-pencil"
              className={'btn-action ' + (barControllMap === 'pencil' && 'active')}
              // onClick={(e) => drawAction(e) + setDrawing(!drawing) + setBarControllMap('pencil')}
              onClick={(e) => {
                drawAction(e)
                setDrawing(!drawing)
                document.getElementsByTagName('html')[0].classList.add('overflow-hidden')
                setBarControllMap('pencil')
              }}
            >
              <i className="icon-pencil"></i>
            </button>
            <button
              id="back-hand_"
              onClick={(e) => {
                setBarControllMap(null)
                document.getElementsByTagName('html')[0].classList.remove('overflow-hidden')
              }}
              className={
                'back-to-hand ' +
                (polygonCoordinates.length === 0 && barControllMap === 'pencil' ? '' : 'd-none')
              }
            >
              <div></div>
              <div></div>
            </button>
          </div>
          <button
            disabled={polygonCoordinates.length !== 0}
            className={
              'btn-searcher ' +
              (map?.getBounds() === coordinatesCheck ? ' disabled-map ' : '') +
              (coordinatesCheck?.length > 0 ? ' active' : '')
            }
            onClick={() => handleSearchProperties(true)}
          >
            Ver resultados en esta zona
          </button>
          <div className="content-button position-relative">
            {/* <div className={"disabled-index " + (polygonCoordinates.length === 0 || coordinatesCheck === undefined ? 'z-index-top' : '')}></div> */}
            <button
              className={
                'btn-trash ' +
                ((polygonCoordinates.length !== 0 ||
                  coordinatesCheck !== undefined ||
                  coordinatesCheck?.length > 0) &&
                  'red-trash')
              }
              style={{ lineHeight: '1' }}
              id="clean"
              onClick={(e) => {
                e.preventDefault()
                cleanerPolygon()
                setBarControllMap(null)
                document.getElementsByTagName('html')[0].classList.remove('overflow-hidden')
                setSkipCenter(true)
              }}
            >
              <i className="icon-trash"></i>
            </button>
          </div>
        </div>
      </div>
    )
  },
)
